<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Confiabilidad</template>
                    <template slot="en">Trustworthiness</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <section class="light-content">
        <div class="container">
            <div v-if="lang == 'es'">
                <p class="text text-secondary">Reporte a la Sunaval (Superintendencia nacional de valores)/Leyes protección a inversionistas minoritarios. Criterio de inversión desarrollado por la experiencia en crecimiento de más valor de empresa.</p>
                <p class="text text-secondary">Somos auditados por empresas reconocidas. Investigación de empresas antes de invertir y acuerdo de gobernabilidad.</p>
                <p class="text text-secondary">Cumplimos con las normativas de buen gobierno corporativo.</p>
            </div>
            <div v-else-if="lang == 'en'">
                <p class="text text-secondary">Our firm periodically reports performance and governance  to Sunaval (National securities commission).</p>
                <p class="text text-secondary">Our firm is subject to national capital markets laws.</p>
                <p class="text text-secondary">Our investment criteria is developed by our broad experience in corporate strategic value growth. </p>
                <p class="text text-secondary">We are periodically audited by recognized firms.</p>
                <p class="text text-secondary">We develop in-depth financial and legal due dilligence procedures before investing.</p>
                <p class="text text-secondary">We comply with good corporate governance guidelines.</p>
            </div>

            <box-container size="4">
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Regulada por Sunaval (Superintendencia Nacional de Valores) e inscrita en la BVC.</template>
                            <template slot="en">Regulated by the Sunaval (National securities comission) and registered and trading in the Caracas Stock Market (BVC).</template>
                        </text-lang>
                    </div>
                </box>
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Inversión directa en empresas con productos tangibles y con presencia en los anaqueles.</template>
                            <template slot="en">Direct investments in companies producing tangible mass-consumption goods or commodities.</template>
                        </text-lang>
                    </div>
                </box>
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Nuestra empresa es auditada y cumple con las pautas de gobierno corporativo.</template>
                            <template slot="en">Our firm is periodically audited and complies with corporate governance guidelines.</template>
                        </text-lang>
                    </div>
                </box>
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Sistemas internos de control de gestión. Supervisión de empresas.</template>
                            <template slot="en">We closely supervise and manage the companies we invest in. </template>
                        </text-lang>
                    </div>
                </box>
            </box-container> 
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import BoxContainer from '@/components/BoxContainer.vue'
import Box from '@/components/Box.vue'
import TextLang from '@/components/TextLang.vue'

export default {
    name: 'trustworthiness',
    props: ['lang'],
    components: {
        Parallax,
        BoxContainer,
        Box,
        TextLang
    }
}
</script>
